// extracted by mini-css-extract-plugin
export default {"wrapper":"CA-z","viewport":"DA-z","container":"EA-z","slide":"FA-z"};